import { isDesktopContext, isFullMode, isZenMode } from 'helpers/desktopApp';
import { isDesktopSamlCallback } from 'helpers/desktopSamlHandoff';
import env from 'helpers/env';
import { isZoomApp } from 'helpers/zoomApp';

import { AnalyticsBrowser } from '@segment/analytics-next';

let platform;

if (isDesktopContext() && isFullMode()) {
  platform = 'desktop full mode';
} else if (isDesktopContext() && isZenMode()) {
  platform = 'desktop zen mode';
} else if (isZoomApp()) {
  platform = 'zoom';
} else {
  platform = 'web';
}

function initializeSegment() {
  if (isDesktopSamlCallback()) return;
  window.segmentV2 = AnalyticsBrowser.load(
    {
      writeKey: env.segmentV2WriteKey
    },
    {
      integrations: {
        'Segment.io': {
          apiHost: 'sega.avoma.com/v1'
        }
      }
    }
  );

  window.segmentV2.addSourceMiddleware(({ payload, next }) => {
    if (payload.obj.type === 'track') {
      if (payload.obj.properties) {
        payload.obj.properties.avoma_platform = platform;
      } else {
        payload.obj.properties = {
          avoma_platform: platform
        };
      }
    }
    next(payload);
  });
}

window.addEventListener('DOMContentLoaded', initializeSegment);
